import {
  Page_Flexiblecontent_Blocks_Accordion,
  Page_Flexiblecontent_Blocks_Accordion_ItemRepeater,
} from "graphql";
import AccordionFragment from "./Fragments/AccordionFragment";
import { FeaturedImage } from "components/FeaturedImage";

interface AccordionProps extends Page_Flexiblecontent_Blocks_Accordion {
  className?: string;
}

const Accordion = ({
  className,
  title,
  sectionCopy,
  itemRepeater,
  headingIcon,
  backgroundColor,
  hasHeadingIcon,
}: AccordionProps) => {
  const hasItems = itemRepeater && itemRepeater.length > 0;

  const hasBackground = backgroundColor && backgroundColor !== `transparent`;

  return (
    <section
      className={`${className} ${
        hasBackground ? `bg-${backgroundColor}-light` : ``
      } w-full py-8`}
    >
      <div className={`${className} container mx-auto flex flex-col gap-6 px-0 md:px-10 lg:px-0`}>
        {hasHeadingIcon ? (
          <div className={`flex justify-center`}>
            <FeaturedImage image={headingIcon} className={`w-24`} />
          </div>
        ) : null}
        {title ? (
          <h2 className={`text-center font-heading text-5xl text-dark`}>
            {title}
          </h2>
        ) : null}
        {sectionCopy ? (
          <div dangerouslySetInnerHTML={{ __html: sectionCopy }} />
        ) : null}

        {hasItems ? (
          <ul>
            {itemRepeater.map((item, i) => {
              return (
                <AccordionFragment
                  className={i === 0 ? `mt-0` : `mt-8`}
                  title={item?.title}
                  content={item?.itemContent ?? ``}
                  i={i}
                  open={i === 0}
                  key={`${i}-question`}
                  hasBackground={hasBackground as boolean}
                />
              );
            })}
          </ul>
        ) : null}
      </div>
    </section>
  );
};

export default Accordion;
